import { Stack, useTheme } from '@mui/material'
import { NodeApi } from 'react-arborist'
import { TreeNode } from 'pages/AccessPointZones/types'

const ICON_WIDTH = 20

const Borders = ({ level, nextSibling, isLastChild, hidePrevBorder = [] }: { level: number, nextSibling: boolean, isLastChild: boolean, hidePrevBorder: boolean[] }) => {
  return (
    <>
      {
        Array.from({ length: level }).map((_, index) => {
          const shouldHideBorder = hidePrevBorder[index] ?? false
          return (
            <Stack key={index} sx={{ width: `${ICON_WIDTH}px`, height: '100%', position: 'relative' }}>
              {
                index < (level - 1) && !shouldHideBorder && (
                  <Stack sx={{
                    position: 'absolute',
                    top: 0,
                    left: 'calc(50% - 0.5px)',
                    height: '100%',
                    borderLeft: 'solid 1px #E5E7EB'
                  }} />
                )
              }
              {
                index === (level - 1) && (
                  nextSibling
                    ? !shouldHideBorder && (
                      <Stack sx={{
                        position: 'absolute',
                        top: 0,
                        left: 'calc(50% - 0.5px)',
                        height: '100%',
                        borderLeft: 'solid 1px #E5E7EB'
                      }} />
                    )
                    : (
                      <>
                        {/* Ligne verticale */}
                        <Stack sx={{
                          position: 'absolute',
                          top: 0,
                          left: 'calc(50% - 0.5px)',
                          height: isLastChild ? 'calc(50% - 5px)' : '100%',
                          borderLeft: 'solid 1px #E5E7EB'
                        }} />
                        {/* Coin arrondi en SVG */}
                        <svg
                          style={{
                            position: 'absolute',
                            top: 'calc(50% - 6px)',
                            left: 'calc(50% - 0.5px)',
                            width: '10px',
                            height: '7px',
                            overflow: 'visible'
                          }}
                        >
                          <path
                            d="M 0 0 L 0 1 Q 0 6, 5 6 L 10 6"
                            fill="none"
                            stroke="#E5E7EB"
                            strokeWidth="1"
                          />
                        </svg>
                      </>
                    )
                )
              }
            </Stack>
          )
        })
      }
    </>
  )
}

type BaseNodeProps = {
  node: NodeApi<TreeNode>
  icon?: string
  hidePrevBorder: boolean[]
  isLastChild: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
  onClick: () => void
  hovered: boolean
  content: React.ReactNode
}

const BaseNode = ({
  node,
  icon,
  content,
  hidePrevBorder,
  isLastChild,
  onMouseEnter,
  onMouseLeave,
  onClick,
  hovered
}: BaseNodeProps) => {
  const theme = useTheme()
  return (
    <Stack
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      gap={.5}
      direction={'row'}
      sx={{
        width: '100%',
        height: '100%',

      }}>
      <Borders level={node.level} isLastChild={isLastChild} nextSibling={!isLastChild} hidePrevBorder={hidePrevBorder} />
      {
        Boolean(icon) && (
          <Stack sx={{ width: `${ICON_WIDTH}px` }} alignItems={'center'} justifyContent={'center'}>
            <i className={icon} style={{ color: theme.palette.primary.main, fontSize: '14px' }} />
          </Stack>
        )
      }
      <Stack
        onMouseEnter={onMouseEnter}
        onMouseOut={onMouseLeave}
        direction={'row'}
        sx={{
          cursor: 'pointer',
          flexGrow: 1,
          padding: 0,
          paddingLeft: '6px',
          justifyContent: 'space-between',
          alignItems: 'center',
          '&:hover': {
            backgroundColor: 'background.primary',
            borderRadius: '6px',
          },
          ...(hovered && {
            backgroundColor: 'background.primary',
            borderRadius: '6px',
          })
        }}
      >
        {content}
      </Stack>
    </Stack>
  )
}

export default BaseNode